export type AuthAccountRoute = {
    id: 'login'
        | 'sso-login'
        | 'forgot-credentials'
        | 'two-factor'
        | 'password-reset'
        | 'password-hint'
        | 'session-timeout'
        | 'session-timeout-sso';
    kind: 'form' | 'two-factor' | 'password-management' | 'session-timeout';
    title: string;
    login_path?: string;
    clear_storage: boolean;
};

const AUTH_ACCOUNT_ROUTES: Record<string, AuthAccountRoute> = {
    '/login': {
        id: 'login',
        kind: 'form',
        title: 'RealINSIGHT Login',
        clear_storage: true,
    },
    '/ribase/login': {
        id: 'login',
        kind: 'form',
        title: 'RealINSIGHT Login',
        clear_storage: true,
    },
    '/sso/login': {
        id: 'sso-login',
        kind: 'form',
        title: 'RealINSIGHT SSO Login',
        clear_storage: true,
    },
    '/ribase/forgotcredentials': {
        id: 'forgot-credentials',
        kind: 'form',
        title: 'RealINSIGHT Forgot Password',
        clear_storage: true,
    },
    '/ribase/twofactor': {
        id: 'two-factor',
        kind: 'two-factor',
        title: 'RealINSIGHT Verification',
        clear_storage: true,
    },
    '/ribase/passwordreset': {
        id: 'password-reset',
        kind: 'password-management',
        title: 'RealINSIGHT Password Reset',
        clear_storage: false,
    },
    '/ribase/passwordhint': {
        id: 'password-hint',
        kind: 'password-management',
        title: 'RealINSIGHT Password Hint',
        clear_storage: false,
    },
    '/ribase/sessiontimeout': {
        id: 'session-timeout',
        kind: 'session-timeout',
        title: 'Session TimeOut',
        login_path: '/RIBase/LogIn',
        clear_storage: true,
    },
    '/ribase/sessiontimeoutsso': {
        id: 'session-timeout-sso',
        kind: 'session-timeout',
        title: 'Session TimeOut',
        login_path: '/SSO/login',
        clear_storage: true,
    },
};

export function getAuthAccountRoute(pathname: string): AuthAccountRoute | undefined {
    const normalized_path = pathname.length > 1 && pathname.endsWith('/')
        ? pathname.slice(0, -1).toLowerCase()
        : pathname.toLowerCase();

    return AUTH_ACCOUNT_ROUTES[normalized_path];
}
